export default {
  api_url: 'https://admin.petrochemenergy.com/api/api/',
  mail_admin: 'ops@petrochemenergy.com',
};
